import { signedPoints } from '../../lib/format';
import type { CardVM } from '../../lib/round';
import { MarketDots } from './shared';

export function PickScoreRow({ pick }: { pick: CardVM }) {
  const clean = pick.anchorState === 'hit' && pick.legs.every((l) => l.state !== 'miss') && pick.legs.length > 0;

  return (
    <div className="rounded-[20px] border border-black/5 bg-card p-[14px_15px] shadow-tile">
      <div className="flex items-center gap-3">
        <div className="min-w-0 flex-1">
          <div className="num text-[14px] font-extrabold tracking-snug text-ink">{pick.fixtureLabel}</div>
          <div className="mt-2 flex items-center gap-[5px]">
            <MarketDots markets={pick.markets} />
            <span
              className={
                clean ? 'text-[10px] font-bold text-accent-ink' : 'text-[10px] font-semibold text-ink2'
              }
            >
              {pick.marketSummary}
            </span>
          </div>
        </div>
        <div className="text-right">
          {pick.formula && pick.points != null && pick.points > 0 && (
            <div className="num text-[11px] font-semibold text-ink2">{pick.formula}</div>
          )}
          <div
            className={`num text-[18px] font-extrabold leading-tight ${
              clean ? 'text-accent-ink' : 'text-ink'
            }`}
          >
            {pick.points != null ? signedPoints(pick.points) : '—'}
          </div>
        </div>
      </div>
    </div>
  );
}
